import { Command } from '@/app/common/base/command'
import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'

export class UpdateMarketingCampaignPreferenceCommand extends Command {
  public async run(preferences: any) {
    await this.client.post('/api/consumers/update-marketing-preference', preferences)
  }
}

export const updateMarketingCampaignPreferenceCommand = new UpdateMarketingCampaignPreferenceCommand(new AxiosClient(), store)
